var map = {
	"./personality-relax-bg-beijing-h5.jpg": "5b9d",
	"./personality-relax-bg-bingdao-h5.jpg": "4339",
	"./personality-relax-bg-riben-h5.jpg": "f832",
	"./personality-relax-bg-shenzhen-h5.jpg": "3427",
	"./personality-relax-bg-taiguo-h5.jpg": "c74d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f75c";